import {
  authenticatedFastApiAxiosInstance,
  authenticatedFastApiAxiosInstanceAllowEmptyString,
} from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import { type APIResponse } from "@/lib/types";
import { type MatterLitigationDateType } from "../../../types/Matter";

export const createMatterLitigationDateTypeV1 = (
  data: Pick<MatterLitigationDateType, "label"> &
    Partial<MatterLitigationDateType>,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .post<
      APIResponse<MatterLitigationDateType>
    >(`${baseFastApiMatterRoute}/litigation-dates/types`, data)
    .then((res) => res.data);
};

export const updateMatterLitigationDateTypeV1 = (
  data: Pick<MatterLitigationDateType, "id" | "dateModified"> &
    Partial<MatterLitigationDateType>,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .patch<
      APIResponse<MatterLitigationDateType>
    >(`${baseFastApiMatterRoute}/litigation-dates/types`, data)
    .then((res) => res.data);
};

export const deleteMatterLitigationDateTypeV1 = (
  data: Pick<MatterLitigationDateType, "id">,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterLitigationDateType>
    >(`${baseFastApiMatterRoute}/litigation-dates/types/${id}`)
    .then((res) => res.data);
};
